module.exports = __webpack_public_path__ + "twitter_squircle_charcoal.svg?9e07ba974f570fd7b406d3a2816741b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/twitter_squircle_charcoal.svg
// module id = 140
// module chunks = 0